module.exports = __webpack_public_path__ + "img/white-cross.834964d6.svg";